/**
 * Conditional Variant Dropdowns for Shopify Dawn Theme
 * Cardinal Valley Industrial Supply
 *
 * - Condition dropdown (New / Remanufactured) filters the Model Number dropdown
 * - New parts: no suffix (e.g. 150BMPE88R54)
 * - Reman parts: -R suffix (e.g. 150BMPE88R54-R)
 * - Some models exist in only one condition
 */

class ConditionalVariants {
  constructor(handle) {
    this.handle = handle;

    // Get product JSON
    const jsonEl = document.getElementById('ProductJson-' + handle);
    if (!jsonEl) return;
    this.product = JSON.parse(jsonEl.textContent);
    this.variants = this.product.variants;

    // Get DOM elements
    this.container   = document.getElementById('CVP-' + handle);
    this.condSelect  = document.getElementById('CVP-Condition-' + handle);
    this.modelSelect = document.getElementById('CVP-Model-' + handle);
    this.variantInput = document.getElementById('CVP-VariantId-' + handle);

    if (!this.container || !this.condSelect || !this.modelSelect) return;

    // Listen for condition change
    this.condSelect.addEventListener('change', () => this.onConditionChange());

// Listen for model change
    this.modelSelect.addEventListener('change', () => this.syncVariant());

    // Filter models and sync on load
    this.onConditionChange();
  }

  onConditionChange() {
    const condition = this.condSelect.value;

    // Get all variants for this condition
    const matching = this.variants.filter(v => v.option1 === condition);

    // Rebuild the model dropdown
    this.modelSelect.innerHTML = '';

    if (matching.length === 0) {
      const opt = document.createElement('option');
      opt.textContent = '— No models available —';
      opt.disabled = true;
      this.modelSelect.appendChild(opt);
      return;
    }

    matching.forEach((variant, i) => {
      const opt = document.createElement('option');
      opt.value = variant.option2;
      opt.textContent = variant.option2;
      opt.dataset.condition = variant.option1;
      if (!variant.available) {
        opt.disabled = true;
        opt.textContent += ' — Sold Out';
      }
      if (i === 0) opt.selected = true;
      this.modelSelect.appendChild(opt);
    });

    this.syncVariant();
  }

  syncVariant() {
    const condition = this.condSelect.value;
    const model     = this.modelSelect.value;

    const matched = this.variants.find(
      v => v.option1 === condition && v.option2 === model
    );

    if (!matched) return;

    // Update hidden variant ID input
    if (this.variantInput) {
      this.variantInput.value = matched.id;
      this.variantInput.dispatchEvent(new Event('change', { bubbles: true }));
    }

    // Update price
    this.updatePrice(matched);

    // Update Add to Cart button
    this.updateCartButton(matched);

    // Update URL
    try {
      const url = new URL(window.location.href);
      url.searchParams.set('variant', matched.id);
      window.history.replaceState({}, '', url.toString());
    } catch(e) {}
  }

  updatePrice(variant) {
    const fmt = cents => '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');

    const wrap    = document.querySelector('.price');
    const regular = document.querySelector('.price__regular .price-item--regular');
    const sale    = document.querySelector('.price__sale .price-item--sale');
    const compare = document.querySelector('.price__sale .price-item--regular');

    if (!regular) return;

    if (variant.compare_at_price > variant.price) {
      wrap?.classList.add('price--on-sale');
      if (sale)    sale.textContent    = fmt(variant.price);
      if (compare) compare.textContent = fmt(variant.compare_at_price);
    } else {
      wrap?.classList.remove('price--on-sale');
      regular.textContent = fmt(variant.price);
    }
  }

  updateCartButton(variant) {
    const btn = document.querySelector('[name="add"]');
    if (!btn) return;
    const label = btn.querySelector('span') || btn;
    if (variant.available) {
      btn.disabled  = false;
      label.textContent = 'Add to cart';
    } else {
      btn.disabled  = true;
      label.textContent = 'Sold out';
    }
  }
}

// Init all conditional pickers on the page
function initCVP() {
  document.querySelectorAll('[id^="CVP-"]').forEach(el => {
    const id = el.id;
    if (id.startsWith('CVP-') && !id.startsWith('CVP-Condition-') && !id.startsWith('CVP-Model-') && !id.startsWith('CVP-VariantId-')) {
      if (!el.dataset.cvpInit) {
        el.dataset.cvpInit = 'true';
        const handle = id.replace('CVP-', '');
        new ConditionalVariants(handle);
      }
    }
  });
}

document.addEventListener('DOMContentLoaded', initCVP);

const observer = new MutationObserver(initCVP);
observer.observe(document.body, { childList: true, subtree: true });
